import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import IndexBar from '../layout/IndexBar';
import Default from './Default';

export default class Case extends Default {
    constructor() {
        super();

        const nav = GetBy.selector('.sidebar-case', this.container)[0]
        const holder = GetBy.selector('.page-case__main', this.container)[0]
        || this.container;
        this.indexNav = nav ? new IndexBar(nav, holder) : null;
    }

    afterShow() {
        super.afterShow();
        // Tras Scroll.init (+100ms items), recalcular anchors
        requestAnimationFrame(() => {
            this.indexNav?.reset();
        });
    }

    afterHide() {
        this.indexNav?.dispose();
        this.indexNav = null;
        super.afterHide();
    }

    resize() {
        super.resize();
        this.indexNav?.resize();
    }

    loop() {
        if (!this._isActive) return;
        super.loop();
        this.indexNav?.loop();
    }
}

ControllerPage._addPage('case', Case);
